"use client";
import { useCallback, useEffect, useState } from "react";
import { useScopedI18n } from "@/messages/client";
import Title from "@/components/ui/title";
import { DirectusImage } from "@/components/DirectusImage";
import RouterLink from "@/components/ui/router-link";
import { MoveRight } from "lucide-react";
import "./index.css";
import { cn } from "@/lib/utils";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from "@/components/ui/carousel";
import useDevice from "@/hooks/useDevice";

export default function NewProductClient(props: {
  data?: {
    slug?: string;
    card_cover?: string;

    name?: string;
    summary?: string;
  }[];
  titleSize?: "lg" | "md" | "sm";
}) {
  const { titleSize = "lg" } = props;
  const t = useScopedI18n("产品");
  const tCommon = useScopedI18n("通用");

  const [mainApi, setMainApi] = useState<CarouselApi | null>(null);
  const [current, setCurrent] = useState(0);

  const { isMobile } = useDevice();

  const onSelect = useCallback(() => {
    if (!mainApi) {
      return;
    }

    setCurrent(mainApi.selectedScrollSnap() || 0);
  }, [mainApi]);

  useEffect(() => {
    if (!mainApi) {
      return;
    }
    onSelect();
    mainApi.on("select", onSelect).on("reInit", onSelect);
  }, [mainApi, onSelect]);

  return (
    <div className="w-full max-md:-ml-6 max-md:w-[100vw]">
      {titleSize === "lg" && <Title title={t("新品推荐")} />}
      {titleSize === "md" && <Title title={t("新品推荐")} underline={false} />}
      {titleSize === "sm" && (
        <Title
          title={t("新品推荐")}
          className="md:items-start md:text-left"
          underline={false}
        />
      )}
      <div className="relative w-full">
        <Carousel
          className="relative mt-4 w-full md:-ml-2 md:mt-12 md:box-content md:px-2"
          setApi={setMainApi}
          opts={{
            loop: true,
            align: "center",
            breakpoints: {
              768: {
                align: "start",
              },
            },
          }}>
          <CarouselContent className="m-0">
            {props.data?.map((el, index) => (
              <CarouselItem
                key={index}
                className="basis-[calc(68vw+16px)] p-2 md:h-[384px] md:basis-1/2 lg:basis-1/3">
                <RouterLink
                  href={el.slug ? `/product/${el.slug}` : undefined}
                  className={cn(
                    "group relative h-full w-full cursor-pointer rounded-md bg-zinc-50 md:hover-outline-shadow",
                    {
                      "opacity-50 md:opacity-100": current !== index,
                    }
                  )}>
                  <img
                    className="absolute right-0 top-0 z-10 w-7 md:w-14"
                    src="/icon/new.png"
                    alt="Icon New Product"
                  />
                  <div className="flex h-[38vw] items-center justify-center overflow-hidden rounded-t-md bg-[url(/product-bg.png)] bg-cover md:h-[218px]">
                    <DirectusImage
                      id={el.card_cover || ""}
                      alt={el.name || ""}
                      zoomInGroup
                      width={256}
                      height={144}
                      className="object-cover"
                    />
                  </div>
                  <div className="flex items-center justify-between px-3 pb-3 pt-3 md:flex-col md:items-start md:justify-start md:px-8 md:pb-0 md:pt-4">
                    <p className="text-base font-bold md:text-lg">{el.name}</p>
                    <div className="hidden md:block">
                      <p className="mt-2 line-clamp-2 text-ellipsis text-sm text-gray">
                        {el.summary}
                      </p>
                    </div>

                    <p className="mt-2 text-right text-xs text-gray">
                      {tCommon("前往了解更多")}
                      <MoveRight className="ml-1 inline" size={14} />
                    </p>
                  </div>
                </RouterLink>
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselPrevious className="custom-prev" />
          <CarouselNext className="custom-next" />
        </Carousel>

        {/* {isMobile && (
          <Carousel
            className="mt-4 w-full"
            opts={{ loop: true }}
            setApi={setMainApi}>
            <CarouselContent className="m-0">
              {props.data?.map((el, index) => (
                <CarouselItem
                  key={index}
                  className="basis-[calc(68vw+16px)] p-2">
                  <RouterLink
                    href={el.slug ? `/product/${el.slug}` : undefined}
                    className={cn(
                      "relative w-full cursor-pointer rounded-md bg-zinc-50",
                      {
                        "opacity-50": current !== index,
                      }
                    )}>
                    <img
                      className="absolute right-0 top-0 z-10 w-7"
                      src="/icon/new.svg"
                      alt="Icon New Product"
                    />
                    <div className="flex h-[38vw] items-center justify-center overflow-hidden bg-[url(/product-bg.png)] bg-cover">
                      <DirectusImage
                        id={el.card_cover || ""}
                        alt={el.name || ""}
                        width={256}
                        height={144}
                        className="object-cover"
                      />
                    </div>
                    <div className="flex items-center justify-between p-3">
                      <p className="text-base font-bold leading-none">
                        {el.name}
                      </p>
                      <p className="text-right text-xs text-gray">
                        {tCommon("前往了解更多")}
                        <MoveRight className="ml-1 inline" size={14} />
                      </p>
                    </div>
                  </RouterLink>
                </CarouselItem>
              ))}
            </CarouselContent>

            <CarouselPrevious className="custom-prev" />
            <CarouselNext className="custom-next" />
          </Carousel>
        )} */}
      </div>
    </div>
  );
}
